<template>
  <b-card>
    <b-card class="multi-card">
      <div slot="header">
        <b-row>
          <b-col md="8">
            <h5>{{ $t('CONFIGURED.FORM_ORDER') }}</h5>
          </b-col>
          <b-col md="4">
            <div class="float-right add-field-btn">
              <i id="popover-target" class="fa fa-lg mr-1 fa-info-circle">
                <b-popover  target="popover-target" triggers="hover" placement="top">
                  {{ $t('COMMON.PROCESS_ORDER_INFO') }}
                </b-popover>
              </i>
              <b-button type="submit" size="sm" variant="secondary" class="mt-0" @click="updateOrder"><i class="fa fa-save"></i> {{ $t('COMMON.SAVE') }}</b-button>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="timeline-div">
        <ul class="timeline timeline-horizontal">
          <draggable v-model="processingOrders" :options="{ group:'processing'}" class="flex-container">
            <li class="timeline-item" v-for="(processingOrder, index) in processingOrders" :key="processingOrder.name">
              <div class="timeline-badge bg-primary"><strong>{{index + 1}}</strong></div>
              <div class="timeline-panel"><p>{{getName(processingOrder.name)}}</p></div>
            </li>
          </draggable>
        </ul>
      </div>
      <em class="italic">{{ $t('CONFIGURED.NOTE') }}</em>
    </b-card>    
  </b-card>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'

export default {
  data () {
    return {
      processingOrders: []
    }
  },
  computed: {
    ...mapGetters(['idToken'])
  },
  components: {
    draggable
  },
  created () {
    let vm = this
    Vue.axios.get('/settings/processing_orders', { headers: { Authorization: `Bearer ${vm.idToken}` } })
      .then(res => {
        vm.processingOrders = res.data.orders
      })
      .catch(error => {
        if (error.status === 401) {
          console.log(this.$t('COMMON.MSG_EXPIRED'))
        } else {
          Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
        }
      })
  },
  methods: {
    updateOrder () {
      var formData = new window.FormData()
      formData.append('processing_orders', JSON.stringify(this.processingOrders))
      Vue.axios.post('/settings/processing_orders/batch_update', formData, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          Vue.toasted.show(this.$t('CONFIGURED.PROCESS_ORDER_SUCCESS'))
        })
        .catch(error => {
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
          console.log(error)
        })
    },
    getName (name) {
      if (name === 'Barcode') {
        return this.$t('PROCESS_ROLES.BARCODE')
      } else if (name === 'Image Match') {
        return this.$t('PROCESS_ROLES.IMAGE_MATCH')
      } else if (name === 'Force Template') {
        return this.$t('PROCESS_ROLES.FORCE_TEMPLATE')
      } else if (name === 'Plain Text') {
        return this.$t('PROCESS_ROLES.PLAIN_TEXT')
      } else {
        return name
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .card {
    background: #ebeff3;
    border-radius: 10px;
  }
  .card-header {
    background: #f7f7f7;
  }
  .timeline-div {
    display: inline-block;
    width: 100%;
    overflow-y: auto;
    background-color: #f7f7f7;
    padding-top: 35px;
    margin: 0 auto;
    margin-bottom: 10px;
  }
  .timeline,
  .timeline-horizontal {
    list-style: none;
    padding: 20px;
    position: relative;
  }
  .timeline:before {
    top: 40px;
    bottom: 0;
    position: absolute;
    content: " ";
    width: 5px;
    background-color: #5b648f;
    margin-left: -1.5px;
  }
  .timeline .timeline-item {
    margin-bottom: 20px;
    position: relative;
  }
  .timeline .timeline-item:before,
  .timeline .timeline-item:after {
    content: "";
    display: table;
  }
  .timeline .timeline-item:after {
    clear: both;
  }
  .timeline .timeline-item .timeline-badge {
    color: #fff;
    width: 60px;
    height: 60px;
    line-height: 52px;
    font-size: 18px;
    text-align: center;
    position: absolute;
    top: 18px;
    left: 50%;
    margin-left: -25px;
    background-color: #7c7c7c;
    border: 5px solid #5b648f;
    z-index: 100;
    border-top-right-radius: 50%;
    border-top-left-radius: 50%;
    border-bottom-right-radius: 50%;
    border-bottom-left-radius: 50%;
    cursor: move;
  }
  .timeline .timeline-item .timeline-badge.primary {
    background-color: #1f9eba;
  }
  .timeline .timeline-item .timeline-panel {
    position: relative;
    width: 20%;
    float: left;
    right: 10px;
    border: 1px solid white;
    background: #ffffff;
    border-radius: 10px;
    cursor: move;
    padding: 5px;
    max-width: 15em;
  }
  .timeline .timeline-item .timeline-panel:before {
    position: absolute;
    top: 26px;
    right: -16px;
    display: inline-block;
    border-top: 16px solid transparent;
    border-left: 16px solid #fff;
    border-right: 0 solid #fff;
    border-bottom: 16px solid transparent;
    content: " ";
  }
  .timeline .timeline-item .timeline-panel p {
      margin: 4px;
      text-align: center;
      font-weight: bolder;
  }
  .timeline-horizontal {
    list-style: none;
    position: relative;
    padding: 20px 0px 20px 0px;
    display: table;
    width: 100%;
  }
  .timeline-horizontal:before {
    height: 5px;
    top: auto;
    bottom: 26px;
    right: 0;
    width: 100%;
    margin-bottom: 20px;
  }
  .timeline-horizontal .timeline-item {
    display: table-cell;
    min-width: 200px;
    float: none !important;
    padding-left: 10px;
    padding-right: 10px;
    margin: 0 auto;
    vertical-align: bottom;
  }
  .timeline-horizontal .timeline-item .timeline-panel {
    top: auto;
    bottom: 36px;
    display: inline-block;
    float: none !important;
    left: 0 !important;
    right: 0 !important;
    width: 100%;
    margin-bottom: 20px;
  }
  .timeline-horizontal .timeline-item .timeline-panel:before {
    top: auto;
    bottom: -16px;
    left: 76px !important;
    right: auto;
    border-right: 16px solid transparent !important;
    border-top: 16px solid #fff !important;
    border-bottom: 0 solid #fff !important;
    border-left: 16px solid transparent !important;
  }
  .timeline-horizontal .timeline-item:before,
  .timeline-horizontal .timeline-item:after {
    display: none;
  }
  .timeline-horizontal .timeline-item .timeline-badge {
    top: auto;
    bottom: 0px;
  }
  ul li.timeline-item{
   max-width: 2em;
  }
  .multi-card .card-body{
    padding: 1.25em 0 0 0;
  }
  .multi-card{
    margin-bottom:0;
  }
  .flex-container {
    display: flex;
    justify-content: center;
  }

  .timeline {
    margin: 0;
  }
  .button-style {
    font-size: 1rem;
    padding-left: 2.5rem;
    padding-right: 2.5rem;
    border-radius: 16px;
  }

  .button-style:nth-child(1) {
    margin-right: .5rem;
  }

  .button-style:nth-child(2) {
    margin-left: .5rem;
  }

  .panel-option:hover {
    cursor: pointer;
  }

  .panel-option {
    display: inline;
    position: absolute;
    right: 0;
    padding: 0 0.2rem;
  }

  .timeline-item .timeline-panel.role-panel {
    display: flex;
    justify-content: center;
  }
</style>
<style>
  .panel-option button {
    color: red;
    background-color: white;
  }
  .panel-option button ,.panel-option button:active:focus,
  .panel-option button:hover, .panel-option button:active,
  .panel-option .btn:not(:disabled):not(.disabled):active{
    color: inherit;
    background-color: inherit;
    border: none;
    box-shadow: none;
    padding: 5px 6px;
  }
</style>


// WEBPACK FOOTER //
// src/components/settings/processOrder.vue